import { z } from "zod";

export const CreateTrackingRequestSchema = z.object({
	companyEnrichIds: z.array(z.string()).max(15).optional(),
	personEnrichIds: z.array(z.number()).max(15).optional(),
	manualLinkedinUrls: z.array(z.string()).max(15).optional(),
});

export const CreateTrackingResponseSchema = z.object({
	listId: z.number(),
	addedCount: z.number(),
});

export type CreateTrackingRequest = z.infer<typeof CreateTrackingRequestSchema>;
export type CreateTrackingResponse = z.infer<typeof CreateTrackingResponseSchema>;
